export function getParams (cKey, filterVal, filterOp) {
  let params
  if (filterVal) {
    params = { filter: {}, op: {} }
    params.filter[cKey] = filterVal
    params.op[cKey] = filterOp
  } else {
    params = cKey
  }
  return params
}



// WEBPACK FOOTER //
// ./src/components/basic-filter/utils.js